import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = (props) => {
  const ref = useRef();
  const [type, setType] = React.useState(
    JSON.parse(localStorage.getItem("authUser")).data.type
  );

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname;

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [props.location.pathname]);

  useEffect(() => {
    ref.current.recalculate();
  });

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }

  return (
    <React.Fragment>
      <SimpleBar className="vertical-simplebar" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            <li>
              <Link to="/dashboard" className="waves-effect">
                <i className="mdi mdi-airplay"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>
           
              <li>
                <Link to="/calendar" className=" waves-effect">
                  <i className="mdi mdi-calendar-text"></i>
                  <span>{props.t("Calendar")}</span>
                </Link>
              </li>
           
            <li>
              <Link to="/news" className=" waves-effect">
                <i className="mdi mdi-bullhorn"></i>
                <span className="badge rounded-pill bg-warning float-end">
                  new
                </span>
                <span>{props.t("Latest News")}</span>
              </Link>
            </li>
            <li>
              <Link to="/how-to-use-lms" className=" waves-effect">
                <i className="mdi mdi-developer-board mdi-spin"></i>
                <span>{props.t("How To Use LMS")}</span>
              </Link>
            </li>
            {type === 1 ? (
              <li>
                <Link to={"whatsapp"} className=" waves-effect">
                  <i className="mdi mdi-whatsapp"></i>
                  <span>{props.t("Apply For Whatsapp")}</span>
                </Link>
              </li>
            ) : (
              <li>
                <Link to={"onsite-whatsapp"} className=" waves-effect">
                  <i className="mdi mdi-whatsapp"></i>
                  <span>{props.t("Apply For Whatsapp")}</span>
                </Link>
              </li>
            )}

            <li className="menu-title">{props.t("Class Activity")}</li>

            {type === 1 ? (
              <li>
                <Link to="/courses" className=" waves-effect">
                  <i className="mdi mdi-message-video"></i>
                  <span>{props.t("Pre Recorded")}</span>
                </Link>
              </li>
            ) : (
              ""
            )}

            <li>
              <Link
                to={type === 1 ? "/zoom-courses" : "/onsite-zoom-courses"}
                className=" waves-effect"
              >
                <i className="mdi mdi-message-video"></i>
                <span>{props.t("My Classes")}</span>
              </Link>
            </li>

            {type === 1 ? (
              <>
                <li>
                  <Link to="/quiz-courses" className=" waves-effect">
                    <i className="mdi mdi-pencil"></i>
                    <span>{props.t("Week Quiz")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/assignments" className=" waves-effect">
                    <i className="mdi mdi-clipboard-text"></i>
                    <span>{props.t("Assignments")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/projects" className=" waves-effect">
                    <i className="mdi mdi-star-circle"></i>
                    <span>{props.t("Projects")}</span>
                  </Link>
                </li>
              </>
            ) : (
            <>
            
            
            <li>
                  <Link to="/onsite-assignments" className=" waves-effect">
                    <i className="mdi mdi-clipboard-text"></i>
                    <span>{props.t("Assignments")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/onsite-projects" className=" waves-effect">
                    <i className="mdi mdi-star-circle"></i>
                    <span>{props.t("Projects")}</span>
                  </Link>
                </li>
            </>
            )}

            <li>
              <Link to="/results" className=" waves-effect">
                <i className="mdi mdi-chart-bar"></i>
                <span>{props.t("Results")}</span>
              </Link>
            </li>
            {type === 1 ? (
              <li>
                <Link
                  to={"certificates"}
                  title="Certificates"
                  className=" waves-effect"
                >
                  <i className="mdi mdi-wallet-giftcard"></i>
                  <span>{props.t("Certificate")}</span>
                </Link>
              </li>
            ) :
              <li>
                <Link
                  to={"onsite-certificates"}
                  title="Certificates"
                  className=" waves-effect"
                >
                  <i className="mdi mdi-wallet-giftcard"></i>
                  <span>{props.t("Certificate")}</span>
                </Link>
              </li>

            }
            {type === 1 ? (
              <li>
                <Link
                  to={"comunity"}
                  title="Certificates"
                  className=" waves-effect"
                >
                  <i className="mdi mdi-forum"></i>
                  <span>{props.t("PFTP Comunity")}</span>
                </Link>
              </li>
            ) : (
              ""
            )}

            {type === 1 ? (
              <li>
                <Link
                  to={"jobs"}
                  title="Job Search"
                  className="waves-effect"
                >
                  <i className="mdi-file-find"></i>
                  <span>{props.t("Job Search")}</span>
                </Link>
              </li>
            ) : (
              ""
            )}

            {/* {type === 1 ? (
              <li>
                <Link
                  to={"select-resume-theme"}
                  title="Make Your Resume"
                  className=" waves-effect"
                >
                  <i className="mdi mdi-newspaper"></i>
                  <span>{props.t("Make Your Resume")}</span>
                </Link>
              </li>
            ) : (
              ""
            )} */}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
